/**
 * Copy text to the clipboard. Resolves true when copied, false when the browser
 * refused (no permission, insecure context, no Clipboard API), so callers can
 * tell the person to copy by hand instead of failing silently.
 * twreact-ui 2.0.2 has no copy primitive; StaffTab, DomainsTab and
 * AssistantConnections still carry their own copies (follow-up ticket).
 */
export async function copyText(text) {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(String(text));
    return true;
  } catch {
    return false;
  }
}
